/**
 * Determines if SmartCard resolution should be skipped for a URL.
 * Returns true for URLs that SmartCard can't resolve, like PDFs.
 */
export const shouldSkipSmartCardResolution = (url: string): boolean => {
	try {
		const urlObj = new URL(url);
		return urlObj.searchParams.has('preview');
	} catch {
		return false;
	}
};
